import { render, staticRenderFns } from "./exteriorStudent.vue?vue&type=template&id=45975044&scoped=true&"
import script from "./exteriorStudent.vue?vue&type=script&lang=js&"
export * from "./exteriorStudent.vue?vue&type=script&lang=js&"
import style0 from "./exteriorStudent.vue?vue&type=style&index=0&id=45975044&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45975044",
  null
  
)

export default component.exports